module.exports = __webpack_public_path__ + "media/peanut_origin_tvc.34d29b26.mp4";